module.exports = __webpack_public_path__ + "img/BSD.c5cc8546.svg";